































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import config from '@/config/index';
import { LoginInterface } from '@/interfaces/Login';
import { Component, Watch } from 'vue-property-decorator';
import router from '@/router';
import Validadores from '@/config/validaRut';
import HandleErrors from '@/config/handleErrors';
import { Funcionalidades } from '@/config/funcionalidades';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, EstadoEntidad, Accion } from '@/config/enums';
import { ParametroSistemaVm } from '@/interfaces/parametroSistema';
import { LoadingService } from '@/services/loadingService';
import moment, { Duration } from 'moment';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import SolicitarClave from '@/pantallas/SucursalVirtual/SolicitarClave/index.vue';
import { MarcaBlanca } from '@/config/marcaBlanca.ts';
import store from '@/store';

if (process.env.NODE_ENV == 'QA') {
  console.log(location.host.split('.')[0]);
  if (location.host.split('.')[0] == 'qagpstrack') {
    import(`../../css/${'track3'}_login_style.css`);
  } else {
    import(
      `../../css/${
        location.hostname == 'localhost'
          ? 'track3'
          : location.host.split('.')[0].substring(3) == ''
          ? '192'
          : location.host.split('.')[0].substring(3)
      }_login_style.css`
    );
  }
} else {
  import(
    `../../css/${
      location.hostname == 'localhost'
        ? 'track3'
        : location.host.split('.')[0] == 'track3s3'
        ? 'track3'
        : location.host.split('.')[0]
    }_login_style.css`
  );
}
@Component({
  components: {
    SolicitarClave,
  },
})
export default class Login extends Vue {
  $snotify: any;
  usuarioId: number = 0;
  email: string = '';
  correoEnviado: boolean = false;
  userData: LoginInterface = { email: '', password: '' };
  userId: string = '';
  userMail: string = '';
  userDataChangePass: any = {
    contrasena1: '',
    contrasena2: '',
    contrasena3: '',
  };
  validForm: boolean = false;
  validForm2: boolean = false;
  validFormActualizaPass: boolean = false;
  dictionaryFormErrors: any = {};
  handleErrors: HandleErrors = new HandleErrors();
  paso1_ok: boolean = false;
  show1: boolean = false;
  show2: boolean = false;
  show3: boolean = false;
  show4: boolean = false;
  vr: Validadores = new Validadores();
  username: string = '';
  recuperarPass: boolean = false;
  usuarioBloqueado: boolean = false;
  debeCambiarPass: boolean = false;
  contactarEjecutivo: boolean = false;
  axios: AxiosVue;
  Controller: string = 'Cuenta';
  controllerParametroSistema: string = 'ParametroSistema';
  axiosGestionUsuario: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  axiosMS = new AxiosVue(ServicioProxy.MS);
  axiosMSLOGIN = new AxiosVue(ServicioProxy.MSLOGIN);
  passRules1: any = [];
  passRules2: any = [];
  passRules3: any = [];
  usuarioBloqueadoBtn: boolean = false;
  mensajeBloqueado: string =
    'Su cuenta ha sido bloqueada por exceder el límite de intentos fallidos, favor de ponerse en contacto con su ejecutivo de cuenta.';
  estadoUsuario: any;
  dialogSesionExpirada: boolean = false;
  dialogpermisosModificados: boolean = false;
  loadingService = new LoadingService();
  esCaducado: boolean = false;
  marcaBlanca: MarcaBlanca = new MarcaBlanca();
  siteKey: string = process.env.VUE_APP_KEY_SITE_CAPTCHA_v2;
  showRecaptcha_v2: boolean = false;

  //Intentos Contraseña
  numIntentos: number = 0;
  numMaxIntentos: number = 0;
  //---

  //Redirección Aceptar Información
  redireccionaAceptarInfo: string = '0';
  //

  //Token Captcha
  tokenCaptcha: string = '';
  typeCaptcha: string = 'v3';
  //

  constructor() {
    super();

    this.axios = new AxiosVue(ServicioProxy.Auth);
  }

  onVerifyCaptcha(token: any) {
    console.log('ENTRADA ONVERIFYCAPTCHA');
    this.showRecaptcha_v2 = false;
    this.tokenCaptcha = token;
    this.typeCaptcha = 'v2';
  }

  showCaptchav2() {
    if (window.grecaptcha && window.grecaptcha.render) {
      this.showRecaptcha_v2 = true;
      //@ts-ignore
      if (!this.$refs.recaptcha.hasAttribute('data-widget-id')) {
        var self = this;
        //@ts-ignore
        window.grecaptcha.render(this.$refs.recaptcha, {
          sitekey: self.siteKey,
          callback: self.onVerifyCaptcha,
        });
      } else {
        console.log('La instancia recaptcha ya existe!');
      }
    } else {
      setTimeout(this.showCaptchav2, 100);
    }
  }

  async created() {
    //Captcha
    await this.$recaptchaLoaded();
    this.tokenCaptcha = await this.$recaptcha('login');
    // Mostrar banner inferior
    let recaptcha = this.$recaptchaInstance;
    recaptcha.showBadge();

    //Redirección Aceptar Información
    this.redireccionaAceptarInfo = window.localStorage.getItem(
      'urlAceptarInformacion'
    );
    //---

    var sesionExpirada = window.localStorage.getItem('showSesionExpirada');
    if (sesionExpirada != null) {
      this.dialogSesionExpirada = true;
      this.loadingService.hideLoading();
      window.localStorage.removeItem('showSesionExpirada');
      console.clear();
    }

    var tokenModificado = window.localStorage.getItem('showLogoutPermisos');
    if (tokenModificado != null) {
      const AxiosTrackService: AxiosVue = new AxiosVue(ServicioProxy.MS);
      const user_id = window.localStorage.getItem('user_id');
      AxiosTrackService.http.post('track/_changeFirstLogin', {
        doFirst: true,
        user_id: user_id,
      });
      this.dialogpermisosModificados = true;
      this.dialogSesionExpirada = false;
      this.loadingService.hideLoading();
      window.localStorage.removeItem('showLogoutPermisos');
      window.localStorage.removeItem('user_id');
      console.clear();
    }

    this.passRules1 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || 'El campo debe tener al menos 8 caracteres.',
    ];
    this.passRules2 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || 'El campo debe tener al menos 8 caracteres.',
      (v: any) =>
        this.userDataChangePass.contrasena2 ==
          this.userDataChangePass.contrasena3 ||
        config.errorMensajes.passNoIguales,
      (v: any) =>
        this.vr.validaFormatoPasswordv2(v) ||
        'Formato de contraseña incorrecto (Vea reglas de contraseña).',
    ];
    this.passRules3 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || 'El campo debe tener al menos 8 caracteres.',
      (v: any) =>
        this.userDataChangePass.contrasena2 ==
          this.userDataChangePass.contrasena3 ||
        config.errorMensajes.passNoIguales,
      (v: any) =>
        this.vr.validaFormatoPasswordv2(v) ||
        'Formato de contraseña incorrecto (Vea reglas de contraseña).',
    ];

    this.dictionaryFormErrors = {
      custom: {
        email: {
          required: () => config.errorMensajes.textoRequerido,
          emailValido: () =>
            'El campo correo electrónico debe ser un correo válido',
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
        contrasena1: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
        contrasena2: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
        contrasena3: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }

  back() {
    this.paso1_ok = false;
    this.userData.email = '';
    this.userData.password = '';
    this.username = '';
    this.recuperarPass = false;
    this.usuarioBloqueado = false;
    this.usuarioBloqueadoBtn = false;
    this.numIntentos = 0;
  }

  mounted() {
    this.registrarValidadores();
  }
  limitString(input: string, length: number): string {
    if (input.length > length) {
      return input.substring(0, length) + '...';
    } else {
      return input;
    }
  }
  beforeMount() {}

  beforeDestroy() {
    // Esconder banner de recaptcha v3
    try {
      let recaptcha = this.$recaptchaInstance;
      recaptcha.hideBadge();
    } catch (e) {
      console.log(e);
    }
  }

  private registrarValidadores() {
    const r = this.vr;
    const self = this;
    Validator.extend('emailValido', {
      getMessage(field: any, params: any, data: any) {
        return 'El campo correo electrónico debe ser un correo válido';
      },
      validate(value: any) {
        return r.validaEmail(value);
      },
    });
  }

  crearContraseña() {
    let url: string = '';
    let arr = [];
    arr = window.location.pathname.split('/');

    if (arr.length >= 3) {
      url = window.location.origin + '/' + arr[1];
    } else {
      url = window.location.origin;
    }
    const hor = new Date().getHours();
    const min = new Date().getMinutes();
    const dia = new Date().getDate();
    const mes = new Date().getMonth();
    const horStr = hor > 9 ? hor.toString() : '0' + hor.toString();
    const minStr = min > 9 ? min.toString() : '0' + min.toString();
    const diaStr = dia > 9 ? dia.toString() : '0' + dia.toString();
    const mesStr = mes > 9 ? mes.toString() : '0' + mes.toString();
    const anoStr = new Date().getFullYear().toString();
    let model = {
      EncodeIdUsuario: btoa(this.usuarioId.toString()),
      From: '',
      To: this.userData.email,
      Subject: 'Track 3.0 - Reestablecer contraseña',
      Message: '',
      EncodedFechaEnvio: btoa(
        minStr + horStr + diaStr + mesStr + anoStr + this.userData.email
      ),
      Url: url,
      esCaducado: this.esCaducado,
      Canal: this.marcaBlanca.getSubDomain(),
    };

    this.$snotify.info('Enviando correo, espere por favor...');
    //this.axios.http
    this.axiosMS.http
      .post(`track/ReestablecerPassword`, model)
      .then(res => {
        if (res.data.CODIGO_RESPUESTA == '1') {
          this.correoEnviado = true;
        } else {
          this.$snotify.error(res.data.MENSAJE_RESPUESTA);
        }
      })
      .catch(err => {
        this.$snotify.error('Ocurrio un error al enviar correo.');
      })
      .finally();
    {
      this.esCaducado = false;
    }
  }

  async continuar(val: any) {
    const res: boolean = await this.$validator.validate('email');
    if (res) {
      this.loadingService.showLoading();
      try {
        const response: any = await this.axios.http.get(
          `${this.Controller}/nombreUsuario?email=${this.userData.email}`
        );
        if (response.data.estado == 5) {
          this.mensajeBloqueado =
            'Su cuenta ha sido bloqueada por exceder el límite de intentos fallidos, favor de ponerse en contacto con su ejecutivo de cuenta.';
          this.usuarioBloqueado = true;
          this.usuarioBloqueadoBtn = true;
        } else if (response.data.estado == 4) {
          this.mensajeBloqueado =
            'Su cuenta ha sido bloqueada. Para solicitar acceso, contacta a tu Ejecutivo de Cuentas.';
          this.usuarioBloqueado = true;
          this.usuarioBloqueadoBtn = false;
        } else {
          this.paso1_ok = true;
        }
        this.username = response.data.nombre + ' ' + response.data.apellidos;
        this.usuarioId = response.data.id;
        this.email = response.data.email;
        this.estadoUsuario = response.data.estado;
        this.numMaxIntentos = response.data.numMaxIntentos;

        if (this.estadoUsuario == EstadoEntidad.Inactivo) {
          this.debeCambiarPass = true;
        }
      } catch (e) {
        this.paso1_ok = false;
        this.$snotify.error('Correo electrónico no se encuentra registrado.');
      } finally {
        this.loadingService.hideLoading();
      }
    }
  }

  private obtenerMoment(valor: string): Duration {
    const regexHoras: RegExp = /^[0-9][0-9]:[0-9][0-9]:[0-9][0-9]$/;

    if (regexHoras.test(valor)) {
      return moment.duration(moment(valor, 'HH:mm:ss').format('HH:mm:ss'));
    }

    return moment.duration(moment(valor, 'DD.HH:mm:ss').format('DD.HH:mm:ss'));
  }

  olvido_pass() {
    if (this.userData.email == '') {
      this.$snotify.error('Debe ingresar un correo electrónico');
      return false;
    } else {
      this.recuperarPass = true;
      this.paso1_ok = false;
    }
  }

  async login() {
    const res1: boolean = await this.$validator.validate('email');
    const res: boolean = await this.$validator.validate('contraseña');
    let clientes: any = [];
    this.esCaducado = false;

    /*if (!res || !res1){
      this.$snotify.error('Debe ingresar un email y contraseña correcto.');
      return false;
    }*/

    if ((res && res1) || (res && this.userData.email != '')) {
      this.loadingService.showLoading();
      try {
        this.numIntentos++;
        let intento = 0;
        const maxIntentos = 3;
        let response: any = null;
        while (intento < maxIntentos) {
          const model = {
            NombreUsuario: this.userData.email,
            Contrasena: this.userData.password,
            canal: this.getSubDomain(),
            recaptchaToken: this.tokenCaptcha,
            typeRecaptcha: this.typeCaptcha,
          };
          try {
            response = await this.axiosMSLOGIN.http.post(``, model);

            if (response.data.CODIGO_RESPUESTA == undefined) {
              this.$snotify.error(
                'Error la validar sesión, intente nuevamente'
              );
              return false;
            } else if (response.data.CODIGO_RESPUESTA == '2') {
              if (response.data.hasOwnProperty('error_code')) {
                if (response.data.error_code == 'timeout-or-duplicate') {
                  await this.$recaptchaLoaded();
                  this.tokenCaptcha = await this.$recaptcha('login');
                  intento++;
                  continue;
                } else if (response.data.error_code == 'low-score') {
                  // sospechas de robot; Se despliega recaptcha v2
                  this.showCaptchav2();
                  return false;
                }
              }

              this.$snotify.error(
                'Ocurrió un error: ' + response.data.MENSAJE_RESPUESTA
              );
              return false;
            }
            break;
          } catch (error) {
            this.$snotify.error('Ocurrió un error: ' + error);
            return false;
          }
        }

        // Si se alcanzó el número máximo de intentos sin éxito
        if (intento === maxIntentos) {
          this.$snotify.error(
            'Se alcanzó el número máximo de intentos, intente nuevamente más tarde.'
          );
          return false;
        }

        if (response.data.estado == 5) {
          this.mensajeBloqueado =
            'Su cuenta ha sido bloqueada por exceder el límite de intentos fallidos, favor de ponerse en contacto con su ejecutivo de cuenta.';
          this.usuarioBloqueado = true;
          this.usuarioBloqueadoBtn = true;
          return false;
        } else if (response.data.estado == 4) {
          this.mensajeBloqueado =
            'Su cuenta ha sido bloqueada. Para solicitar acceso, contacta a tu Ejecutivo de Cuentas.';
          this.usuarioBloqueado = true;
          this.usuarioBloqueadoBtn = false;
          return false;
        }

        this.paso1_ok = true;
        if (response.data.estado == EstadoEntidad.Inactivo) {
          this.userMail = response.data.usuario;
          this.userId = response.data.u;
          this.debeCambiarPass = true;
          return false;
        }

        if (response.data.code == 0) {
          if (window.localStorage) {
            window.localStorage.setItem('sendMsgCliente', '1');
            window.localStorage.setItem('token', response.data.token);
            window.localStorage.setItem(
              'user',
              JSON.stringify(response.data.usuario)
            );
          }

          // Esconder captcha_v2 si está abierto
          try {
            const recaptchaEle = this.$refs.recaptcha;
            //@ts-ignore
            recaptchaEle.style.display = 'none';
          } catch (e) {
            console.log('cierre Captcha ' + e);
          }

          this.$store.commit('setToken', response.data.token);
          this.$store.commit('authUser', response.data.usuario);

          //recuperacion de ultimo cliente del usuario
          let axiosGestionUsuario: AxiosVue = new AxiosVue(
            ServicioProxy.GestionUsuario
          );
          let axiosGestionMs: AxiosVue = new AxiosVue(ServicioProxy.MS);

          let uiModel: any = {
            UsuarioId: response.data.usuario.id,
            ClienteId: 0,
            Componente: 'Inicio',
            Funcionalidades: Funcionalidades.Inicio,
          };

          await this.axiosMS.http
            .post(
              `Metabase/PostgenericA/searchFilter/get_clients2?user_id=${response.data.usuario.id}`,
              { user_id: response.data.usuario.id }
            )
            .then(async res => {
              console.log('res clientes: ', res);
              clientes = res.data.data;

              clientes = await clientes.filter(
                (x: any) => x.accesoUsuarios === true
              );
            })
            .catch(error => {
              console.log('error: ', error);
            });

          const userClient: any = await axiosGestionMs.http.post(
            `Metabase/PostgenericA/avl_track_login/estado_ui_track3`,
            uiModel
          );

          if (userClient.data.clienteId !== 0 && clientes.length > 0) {
            const _cliente = clientes.find(
              (x: any) => x.clienteId == userClient.data.clienteId
            );
            if (_cliente != undefined) {
              localStorage.setItem('clienteDefecto', userClient.data.clienteId);
            } else {
              localStorage.setItem('clienteDefecto', clientes[0].clienteId);
            }
          } else {
            window.localStorage.setItem(
              'clienteDefecto',
              response.data.usuario.clienteDefecto
            );
          }
          //get homePath
          const gethomePath = await axiosGestionMs.http
            .get(`avl_track_login/home_path_track3`)
            .then(res => {
              console.log('res: ', res);
              var homePath = res.data.homePath;
              this.$store.commit('setHomePath', homePath);
            });

          //Redirección Aceptar Información
          if (this.redireccionaAceptarInfo === '1') {
            window.localStorage.removeItem('urlAceptarInformacion');
            router.replace('/aceptarinformacion');
            this.$snotify.clear();
          } else {
            window.localStorage.removeItem('urlAceptarInformacion');

            // Generar funcionalidades:
            await this.reprocesoPermisoUsuario(
              localStorage.getItem('clienteDefecto'),
              response.data.usuario.id
            );

            // Validar si se encuentra en un cliente canal o en el de gpschile
            let url: string = window.location.href;
            // Utilizamos una expresión regular para extraer el subdominio de la URL
            var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

            // Si se encontró un subdominio, lo retornamos
            if (subdominio && subdominio.length > 1) {
              switch (
                subdominio[1]
                  .split(':')[0]
                  .toString()
                  .toLowerCase()
              ) {
                case 'gpstrack':
                  router.push('/');
                  this.$snotify.clear();
                  break;
                case 'track3':
                  router.push('/');
                  this.$snotify.clear();
                  break;
                case 'qagpstrack':
                  router.push('/');
                  this.$snotify.clear();
                  break;
                case 'localhost':
                  router.push('/');
                  this.$snotify.clear();
                  break;
                default:
                  router.push('/tracker');
                  this.$snotify.clear();
                  break;
              }
            } else {
              router.push('/');
              this.$snotify.clear(); // No se encontró un subdominio
            }
          }
        } else if (response.data.code == 1) {
          this.contactarEjecutivo = true;
          this.paso1_ok = false;
        } else if (response.data.code == 2) {
          this.esCaducado = true;
          this.$snotify.error(
            'Su contraseña ha caducado, por favor restablezca su contraseña'
          );
          this.recuperarPass = true;
          this.paso1_ok = false;
        } else if (response.data.code == 3) {
          this.$snotify.error(
            'Usuario no se encuentra activo, comuníquese con el Administrador.'
          );
        } else if (response.data.code == 4) {
          this.usuarioBloqueado = true;
          this.mensajeBloqueado =
            'Su cuenta ha sido bloqueada por exceder el límite de intentos fallidos, favor de ponerse en contacto con su ejecutivo de cuenta.';
          this.usuarioBloqueadoBtn = true;
          this.paso1_ok = true;
        }
      } catch (error) {
        this.$snotify.error(
          'Inicio de sesión incorrecto. Compruebe contraseña'
        );
        // if (
        //   error.response.status !== undefined &&
        //   error.response.status == '404'
        // ) {
        //   this.$snotify.error(
        //     'Usuario no se encuentra activo, comuníquese con el Administrador.'
        //   );
        // }  else {
        // if (this.numIntentos < this.numMaxIntentos) {
        //   this.$snotify.error(
        //     'Inicio de sesión incorrecto. Compruebe contraseña'
        //   );
        // } else {
        //   this.recuperarPass = true;
        //   this.paso1_ok = false;
        // }
        // }
      } finally {
        this.loadingService.hideLoading();
      }
    }
  }

  async reprocesoPermisoUsuario(clienteId: any, usuarioId: any) {
    var self = this;
    // await this.axiosAuth.http
    //   .post(
    //     `${this.ControllerCuenta}/usuarioFuncionalidadesCliente/${this.usuario.id}/${clienteId}`
    //   )
    await this.axiosMS.http
      .post(`Metabase/PostgenericA/cuenta/usuarioFuncionalidadesCliente`, {
        userId: usuarioId,
        clientId: clienteId,
      })
      .then((response: any) => response.data)
      .then(async function(response: any) {
        ///////////////////////////////////////////////////////////////////////////////////////
        if (window.localStorage) {
          window.localStorage.setItem('token', response.data.token);

          const localUser = store.state.user;
          let user: any = {};
          if (localUser.id != undefined || localUser != null) {
            user = Object.assign({}, localUser, response.data.usuario);
          } else {
            user = response.data.usuario;
          }
          window.localStorage.setItem('user', JSON.stringify(user));
          window.localStorage.setItem('clienteDefecto', clienteId.toString());
        }
        self.$store.commit('setToken', response.data.token);
        self.$store.commit('authUser', response.data.usuario);
        ///////////////////////////////////////////////////////////////////////////////////////
      })
      .catch(function(error: any) {
        console.log('Error al procesar usuarioFuncionalidadesCliente: ', error);
      })
      .finally(function() {
        self.loadingService.hideLoading();
      });
  }

  changeInput() {
    var formVal: any = this.$refs;
    formVal.form.validate();
  }

  actualizarPassLogin() {
    this.loadingService.showLoading(); //Muestra Cargando

    var formVal: any = this.$refs;
    //if (formVal.form.validate()) {
    //valida contraseña
    if (
      this.vr.validaFormatoPasswordv2(
        this.userDataChangePass.contrasena2.toString().trim()
      ) === true
    ) {
      let validaModel: any = {
        NombreUsuario: this.userMail,
        old: this.userDataChangePass.contrasena1,
        Contrasena: this.userDataChangePass.contrasena2,
        RepetirContrasena: this.userDataChangePass.contrasena3,
        UsuarioId: this.userId,
      };

      this.axiosMS.http
        .post(`track/restablecer_pass`, validaModel)
        .then(res => {
          if (res.data.CODIGO_RESPUESTA == '1') {
            this.loadingService.hideLoading(); //Oculta Cargando
            this.$snotify.success(
              'La Contraseña ha sido actualizada de forma exitosa'
            );

            this.userData.email = '';
            this.userData.password = '';
            this.paso1_ok = false;
            this.recuperarPass = false;
            this.debeCambiarPass = false;
            this.usuarioBloqueado = false;
          } else {
            this.$snotify.error(res.data.MENSAJE_RESPUESTA);
            this.loadingService.hideLoading(); //Oculta Cargando
          }
        })
        .catch(err => {
          this.$snotify.error('Error de conexión');
          this.loadingService.hideLoading(); //Oculta Cargando
        });

      /*this.axios.http
        .post(`${this.Controller}/checkCurrentPassword`, validaModel)
        .then(res => {
          if (
            this.userDataChangePass.contrasena1 ===
            this.userDataChangePass.contrasena2
          ) {
            this.loadingService.hideLoading(); //Oculta Cargando
            this.$snotify.warning(
              'Nueva contraseña no puede ser igual a la anterior.'
            );
            return;
          }

          let model: any = {
            UsuarioId: this.usuarioId,
            Contrasena: this.userDataChangePass.contrasena2,
            RepetirContrasena: this.userDataChangePass.contrasena3,
          };

          this.axios.http
            .post(`${this.Controller}/changepass`, model)
            .then(res => {
              this.axios.http
                .put(`${this.Controller}/${this.usuarioId}/cambiarEstado`)
                .then(res => {
                  this.loadingService.hideLoading(); //Oculta Cargando
                  this.$snotify.success(
                    'Contraseña actualizada correctamente.'
                  );

                  formVal.form.reset();
                  this.paso1_ok = false;
                  this.recuperarPass = false;
                  this.debeCambiarPass = false;
                  this.usuarioBloqueado = false;
                })
                .catch(error => {
                  this.loadingService.hideLoading(); //Oculta Cargando
                  this.$snotify.error(
                    'Ocurrio un error al actualizar estado de usuario.'
                  );
                });
            })
            .catch(error => {
              this.loadingService.hideLoading(); //Oculta Cargando
              this.$snotify.error('Ocurrio un error al actualizar contraseña.');
            });
        })
        .catch(err => {
          this.loadingService.hideLoading(); //Oculta Cargando
          this.$snotify.error('Contraseña actual incorrecta.');
        });
        */
    } else {
      this.loadingService.hideLoading(); //Oculta Cargando
      this.$snotify.error(
        'Contraseña no cumple las reglas básicas de validación para su generación.'
      );
    }
    //}
  }

  goToRegister() {
    this.$router.push('/registro');
  }
  limpiarForm() {
    this.userData.email = '';
    this.userData.password = '';
  }

  getSubDomain() {
    //let url: string = "http://qa-betterfield.gpschile.com/";
    //let url: string = "https://track3.gpschile.com/tracker";
    let url: string = window.location.href;
    // Utilizamos una expresión regular para extraer el subdominio de la URL
    var subdominio = url.match(/^(?:https?:\/\/)?([^/.]+)/i);

    // Si se encontró un subdominio, lo retornamos
    if (subdominio && subdominio.length > 1) {
      return subdominio[1].split(':')[0];
    } else {
      return ''; // No se encontró un subdominio
    }
  }
}
